import { cloneDeep, uniqueId } from 'lodash';
import { Editor, Element as SlateElement } from 'slate';

import { SLATE_TEXT_FORMATS, slateToText } from 'src/components/RichSlate';
import { isNonEnglish } from 'src/data/generation';

const parseScore = (score) => {
  try {
    const parsed = parseInt(score, 10);
    return parsed || 0;
  } catch (e) {
    return 0;
  }
};

export const collectDDVariationFromEditor = (editor, excludeNonEnglish) => {
  const version = uniqueId();

  const nodes = Array.from(
    Editor.nodes(editor, {
      at: [],
      match: (n) =>
        !Editor.isEditor(n) &&
        SlateElement.isElement(n) &&
        n.type === SLATE_TEXT_FORMATS.DD_VARIATION &&
        excludeNonEnglish
          ? !isNonEnglish(n.variation?.language)
          : true,
    })
  );
  return nodes.reduce((acc, [node]) => {
    if (node.type === SLATE_TEXT_FORMATS.DD_VARIATION) {
      acc.push({
        ...node.variation,
        score: parseScore(node.variation.score),
        editorValue: cloneDeep(node.children),
        text: slateToText(node.children),
        version,
      });
    }
    return acc;
  }, []);
};
